type RoutedServiceUser = {
  value: string;
  label: string;
};

type VisitTaskSource = {
  _id?: string;
  origin?: { _id?: string };
  serviceUser?: {
    _id?: string;
    name?: string;
  } | null;
};

type VisitTaskContext = {
  visit?: string;
  origin?: string;
  serviceUser?: string;
};

export const getVisitTaskContext = (
  visit?: VisitTaskSource
): VisitTaskContext => {
  if (!visit?._id || !visit.serviceUser?._id) {
    return {};
  }

  return {
    visit: visit._id,
    ...(visit.origin?._id ? { origin: visit.origin._id } : {}),
    serviceUser: JSON.stringify({
      value: visit.serviceUser._id,
      label: visit.serviceUser.name || "Service user",
    }),
  };
};

export const parseSelectedServiceUser = (
  value: string | string[] | undefined
): RoutedServiceUser | null => {
  if (typeof value !== "string") {
    return null;
  }

  try {
    const parsed = JSON.parse(value);
    if (
      typeof parsed?.value !== "string" ||
      typeof parsed?.label !== "string"
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};
